<template>
  <div
    v-if="isLoading"
    class="loader">
    <div class="text">
      <span
        v-for="(letter, index) in title"
        :key="index"
        class="letter"
        :style="{ '--delay': index * 0.02 + 's' }">
        {{ letter === ' ' ? '&nbsp;' : letter }}
      </span>
    </div>
    <div class="dots">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <transition-group
      name="fade"
      tag="div"
      class="message-wrapper">
      <div
        class="message"
        v-if="currentMessage"
        :key="currentMessage"
        style="position: absolute">
        {{ currentMessage }}
      </div>
      <div
        class="message-placeholder"
        v-if="currentMessage"
        :key="currentMessage + 'placeholder'">
        >
        {{ currentMessage }}
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
    messages: {
      type: Array,
      default: () => [
        'Laddar...', // Swedish
        'Indlæser...', // Danish
        'Laster...', // Norwegian
        'Ladataan...', // Finnish
        'Hleð...', // Icelandic
        'Sæki...', // Faroese
        'Cargando...', // Spanish
      ],
    },
  },
  data() {
    return {
      title: 'Business Board'.split(''),
      currentMessage: '',
      messageIndex: 0,
      interval: null,
    };
  },
  mounted() {
    if (this.messages.length > 0) {
      this.changeMessage();
      this.interval = setInterval(this.changeMessage, 3000);
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    changeMessage() {
      if (this.messages.length > 0) {
        this.$set(this, 'currentMessage', this.messages[this.messageIndex]);
        this.messageIndex = (this.messageIndex + 1) % this.messages.length;
      }
    },
  },
};
</script>

<style scoped>
.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  margin-top: 4.3rem;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #27645c;
  z-index: 9999;
  font-size: 2em;
  color: white;
  pointer-events: none;
}

.text {
  display: flex;
  align-items: center;
  margin-bottom: 0.5em;
  font-family: 'SoraRegular', sans-serif;
  font-weight: 700;
  animation: fadeIn 0.4s forwards;
}

.letter {
  opacity: 0;
  animation: fadeIn 0.6s forwards;
  animation-delay: var(--delay);
}

.message-wrapper {
  margin-top: 1em;
  min-height: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
}

.message-placeholder {
  visibility: hidden;
}

.loader.fade-out {
  animation: fadeOut 2s forwards;
}

.dots span {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin: 0 4px;
  background: #fff;
  border-radius: 50%;
  opacity: 0;
  animation: bounce 0.6s infinite alternate, fadeIn 1s forwards;
}

.dots span:nth-child(2) {
  animation-delay: 0.2s, 1s;
}

.dots span:nth-child(3) {
  animation-delay: 0.4s, 1s;
}

@keyframes bounce {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-15px);
  }
}

@keyframes fadeInOut {
  0%,
  100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.95;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
